import { render, staticRenderFns } from "./emailReport.vue?vue&type=template&id=207adb73&"
import script from "./emailReport.vue?vue&type=script&lang=js&"
export * from "./emailReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports